import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';
import { InitialState } from '../reducers/teams';

const getState = (state: RootState) => state.teams;

export const getSelectedTeam = createSelector(getState, (teams: InitialState) => teams.activeTeam);
export const getTeamLoading = createSelector(getState, (teams) => teams.loading);
export const getTeamEmployeesFilters = createSelector(getState, (teams) => teams.filters);
